import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import service, { VERIFICATION_TOKEN } from 'kts-platform-frame/service';
import Urls from 'src/entry/constant/Urls';
import { message } from 'antd';
import JSObject from 'kts-scaffold-framework/utils/kit/JSObject';
import AppSdk from 'kts-platform-frame/appSdk';


class ModulesAction extends ActionBasic<ModulesState> {

    /** 更新 */
    updateAppList = async (): Promise<void> => {
        const url = Urls.queryCatoryApp; //'/open-platform/app/instance/user-conf/query-my';
        let appCategoryName;
        const { searchInfo, appCategoryList } = this.modulesState;
        if(searchInfo.appCategoryId) {
            const categrory = appCategoryList.find(item => item.categoryId === searchInfo.appCategoryId); 
            if(categrory) {
                appCategoryName = categrory.categoryName;
            }
        }
        let fields = {
            "appCategoryName": appCategoryName,
            "isPopular": '', //没有筛选是否常用的入口，
            "location": '',
            "searchKey": searchInfo.appName
        };
        fields = JSObject.getClearBlankParas(fields);
        fields = JSObject.clearBlankArray(fields);
        const query = await service.post(url, fields).reqFs(VERIFICATION_TOKEN).end(this);
        if (query.err) {
            return;
        }
        this.modulesState.myAppList = query.res;
        this.setModulesState();
    }
    // 分类
    queryCatory = async (): Promise<void> => {
        this.modulesState.myAppList = [];
        this.setModulesState();
        const url = Urls.queryCatory; //'/open-platform/app/instance/user-conf/query-my';
        const query = await service.get(url, {}).reqFs(VERIFICATION_TOKEN).end(this);
        if (query.err) {
            return;
        }
        this.modulesState.appCategoryList = query.res;
        this.setModulesState();
    }
    /** 快捷设置常用 */
    quickSetUsed = async (item): Promise<void> => {
        const url = Urls.userConfUpset;
        const res = await service.post(url, {
            instanceId: item.instanceId,
            isPopular: item.isPopular === 0 ? 1 : 0
        }).reqFs(VERIFICATION_TOKEN).end(this);
        // console.log(res, 'ss');
        if (res.err) {
            message.destroy();
            message.error(res.err.body.status.description);
        }
        //this.updateAppList();
        AppSdk.instance.sendEvent('myAppChangeEvent', {});

    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/apps/AppSearch/Modules.Action.ts